"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTypes = void 0;
var FileTypes;
(function (FileTypes) {
    FileTypes["ACCOUNT_STATEMENT"] = "account-statement";
    FileTypes["PRE_INVOICE"] = "pre-invoice";
    FileTypes["PAYMENT_PROOF"] = "payment-proof";
    FileTypes["INVOICE"] = "invoice";
    FileTypes["XML_INVOICE"] = "xml-invoice";
})(FileTypes || (exports.FileTypes = FileTypes = {}));
//# sourceMappingURL=file-types-dto.js.map